import { render } from "./LinkExpired.vue?vue&type=template&id=4244b857&scoped=true"
import script from "./LinkExpired.vue?vue&type=script&lang=js"
export * from "./LinkExpired.vue?vue&type=script&lang=js"

import "./LinkExpired.vue?vue&type=style&index=0&id=4244b857&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4244b857"]])

export default __exports__